import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ButtonPushComponent, TitleComponent } from "../../components";
import { ModalLayout } from "../../layouts";
import { requestDelete } from "../../services/requestDelete";
import { requestUpdateAuthorization } from "../../services/requestUpdate";
import { ModalContainer } from "../ModalContainer/ModalContainer";

export const ProductCollectionDetailHeaderContainer = () => {
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);

  const body = useSelector((state) => state.collection);

  const path = useParams();
  const navigate = useNavigate();
  const updateCollection = () => {
    const token = localStorage.getItem("token");
    requestUpdateAuthorization(
      `admin/colecciones/${path.collectionId}/`,
      body,
      token
    );
    navigate("/productos/colecciones");
  };

  const onOpenConfirmd = () => {
    setIsOpenConfirm(!isOpenConfirm);
  };

  const onCloseCanceled = () => {
    setIsOpenDelete(!isOpenDelete);
  };

  const deleteCollection = () => {
    const token = localStorage.getItem("token");
    requestDelete(`admin/colecciones/${path.collectionId}/`, token).then(() =>
      navigate("/productos/colecciones")
    );
  };

  const canceledStateStyle = {
    fontSize: "15px",
    fontWeight: "bold",
  };
  return (
    <section className="OrderDetailHeaderContainer">
      <div className="OrderDetailHeaderContainer__title">
        <TitleComponent title="Detalle de la Colección" />
      </div>
      <div className="OrderDetailHeaderContainer__container-button">
        <ButtonPushComponent
          name={"Eliminar"}
          color={"red"}
          onClick={onCloseCanceled}
        />
        <ButtonPushComponent name={"Guardar"} onClick={onOpenConfirmd} />
      </div>

      {isOpenDelete && (
        <ModalLayout>
          <ModalContainer
            title="Eliminar Colección"
            msg="¿Está seguro que desea eliminar el producto?"
            style={canceledStateStyle}
            onClose={onCloseCanceled}
            onConfirm={deleteCollection}
          />
        </ModalLayout>
      )}

      {isOpenConfirm && (
        <ModalLayout>
          <ModalContainer
            title="Editar Colección"
            msg="¿Está seguro que desea editar la Colección?"
            style={canceledStateStyle}
            onClose={onOpenConfirmd}
            onConfirm={updateCollection}
          />
        </ModalLayout>
      )}
    </section>
  );
};
